$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

require("./swall");
require("./quill");
require("./select2");

window.Quill = require("quill");
document.addEventListener("DOMContentLoaded", function (event) {
    var toolbarOptions = [
        [{ header: [2, 3, 4, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
    ];

    //     var containers = $('.is-text');

    //     containers.each(function (i) {
    //         const name = $(this).data('name');
    //         const container = containers.get(i)
    //         const editor = new Quill(container, {
    //             modules: {
    //                 toolbar: toolbarOptions
    //             },
    //             theme: 'snow',
    //             height: 15
    //         });
    //         editor.on('text-change', function () {

    //             let justHtml = editor.root.innerHTML;
    //             let cleanHtml = justHtml.replaceAll('"', "'")
    //             $('input[data-bubble="' + name + '"]').val(cleanHtml);
    //             // var element = document.querySelector('input[data-bubble="' + name + '"]');
    //             // console.log('name', name);
    //             // console.log('data', cleanHtml);
    //             // var event = new CustomEvent('change', {name, cleanHtml});
    //             // element.dispatchEvent(event);
    //         });

    //     }).end();

    // No es necesario para seguir mostrando el submenu
    // let currentUrl = window.location.href;
    // const searchStrings = [
    //     "discover",
    //     "health-and-safety",
    //     "about-us",
    //     "tools",
    //     "legal-text",
    // ];

    // activityStrings = [
    //     "activity-logs"
    // ];
    // const contentmenus = document.querySelectorAll(".content-collapse");
    // const activitymenus = document.querySelectorAll(".activity-collapse");

    // contentmenus.forEach(function (menu) {
    //     for (let i = 0; i < searchStrings.length; i++) {
    //         let searchString = searchStrings[i];

    //         if (currentUrl.includes(searchString)) {
    //             menu.classList.add('submenu-open');
    //         }
    //     }
    // });
    // activitymenus.forEach(function (menu) {
    //     for (let i = 0; i < activityStrings.length; i++) {
    //         let searchString = activityStrings[i];

    //         if (currentUrl.includes(searchString)) {
    //             menu.classList.add('submenu-open');
    //         }
    //     }
    // });
});

$(document).ready(function () {
    $(".remove-img").on("click", function () {
        const model = $(this).data("model");
        const lang = $(this).data("lang");
        const page = $(this).data("page");
        const column = $(this).data("column");
        const label = $("#" + $(this).data("id"));

        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#0E7490",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            $.ajax({
                url: "/delete-img",
                method: "POST",
                dataType: "JSON",
                data: {
                    model: model,
                    lang: lang,
                    page: page,
                    column: column,
                    _token: $('meta[name="csrf-token"]').attr("content"),
                },
                success: function (res) {
                    window.location.reload();
                },
            });
            if (result.isConfirmed) {
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
            }
        });
    });
});
